import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, normalizeClass as _normalizeClass, withModifiers as _withModifiers, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/dashboards/my-reports-icon.png'


const _withScopeId = (n: any) => (_pushScopeId("data-v-083c6d07"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "text-center" }, "Change Pathway?", -1))
const _hoisted_3 = {
  key: 1,
  class: "text-danger",
  "data-test": "change-outcome-error"
}
const _hoisted_4 = {
  key: 2,
  "data-test": "selecting-solo-report-pathway-msg"
}
const _hoisted_5 = {
  key: 3,
  "data-test": "change-outcome-msg"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Oh no! If this pathway doesn't suit your current development then you can change it.", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Changing your Pathway will affect your current progress. Click ‘Yes’ and you will be prompted to pick another Pathway. ", -1))
const _hoisted_8 = [
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = { class: "dashboard-background" }
const _hoisted_11 = { class: "container maxWidth-md text-big" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-sm-6 left-column" }
const _hoisted_14 = { class: "col-sm-6 right-column" }
const _hoisted_15 = { class: "row top-row" }
const _hoisted_16 = { class: "col-sm-6 panel-container" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { "data-test": "solo-menu-item-0" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/soloreport/" }, "View Solo Report")
], -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { "data-test": "solo-menu-item-1" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/resources/session/gyreinsights-your-solo-report" }, [
    /*#__PURE__*/_createElementVNode("span", null, "GyreInsights: Solo report"),
    /*#__PURE__*/_createElementVNode("span", { class: "beta-sticker" }, "BETA")
  ])
], -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { "data-test": "solo-menu-item-2" }, [
  /*#__PURE__*/_createElementVNode("a", {
    role: "button",
    tabindex: "0",
    style: {"padding":"0"},
    "aria-label": "review yourself again"
  }, [
    /*#__PURE__*/_createElementVNode("form", {
      action: "/review/reviewyourselfagain",
      method: "post"
    }, [
      /*#__PURE__*/_createElementVNode("input", {
        type: "submit",
        value: "Create new solo report",
        class: "repeat-strengths-mapping-input",
        "data-test": "repeat-solo-link"
      })
    ])
  ])
], -1))
const _hoisted_20 = { class: "col-sm-6 panel-container" }
const _hoisted_21 = {
  key: 0,
  "data-test": "viewpoints-menu-item-0"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/viewpoints/" }, "View Viewpoints Report", -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 1,
  "data-test": "viewpoints-menu-item-1"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/resources/session/gyreinsights-your-viewpoints-report" }, [
  /*#__PURE__*/_createElementVNode("span", null, "GyreInsights: Viewpoints report"),
  /*#__PURE__*/_createElementVNode("span", { class: "beta-sticker" }, "BETA")
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { "data-test": "viewpoints-menu-item-3" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "/my/pathway/viewpoints-invite" }, " Viewpoints pathway ")
], -1))
const _hoisted_28 = {
  key: 2,
  "data-test": "viewpoints-menu-item-4"
}
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "/my/pathway/working-with-your-viewpoints-report" }, " Working with my Viewpoints Report pathway ", -1))
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = {
  key: 0,
  class: "no-viewpoints-container",
  "data-test": "no-viewpoints-content"
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " You need at least two Viewpoints reports before you can view your Viewpoints report. ", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", {
  href: "/my/pathway/viewpoints-invite",
  class: "btn btn-default",
  "data-test": "viewpoints-pathway-btn"
}, "Viewpoints pathway", -1))
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "row bottom-row" }
const _hoisted_36 = { class: "col-sm-6 panel-container" }
const _hoisted_37 = { "data-test": "my-reports-menu-item-0" }
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  alt: "My Reports",
  src: _imports_0,
  class: "my-reports-panel-image",
  "data-test": "my-reports-panel-image"
}, null, -1))
const _hoisted_39 = { class: "col-sm-6 panel-container" }
const _hoisted_40 = {
  key: 0,
  "data-test": "develop-tile-content",
  class: "develop-container"
}
const _hoisted_41 = {
  class: "develop-strength",
  "data-test": "develop-tile-strength"
}
const _hoisted_42 = { key: 0 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "develop-strength" }, ":", -1))
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", { "data-test": "develop-tile-complete" }, "Complete 🎉", -1))
const _hoisted_46 = [
  _hoisted_43,
  _hoisted_44,
  _hoisted_45
]
const _hoisted_47 = {
  key: 1,
  "data-test": "develop-tile-day",
  class: "develop-day-of-25"
}
const _hoisted_48 = {
  key: 2,
  "data-test": "develop-tile-button",
  class: "btn btn-lg btn-default choose-new-plan-btn"
}
const _hoisted_49 = {
  key: 1,
  "data-test": "develop-tile-content",
  class: "begin-develop-container"
}
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Once you begin your Develop plan, progress will be shown here.", -1))
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  "data-test": "develop-tile-button",
  class: "btn btn-lg btn-default"
}, " Choose a plan ", -1))
const _hoisted_52 = [
  _hoisted_50,
  _hoisted_51
]

import { computed, ref, watch } from "vue";
import { debug as d } from "debug";
import { Modal } from "uiv";
import DashboardPanel from "../../components/dashboard-panel.vue";
import DashboardOutcomeTile from "../../components/dashboard-tiles/dashboard-outcome-tile.vue";
import DevelopProgress from "../../components/develop-progress.vue";
import HeadFromModel from "../../components/head/head-from-model.vue";
import { csContext } from "../../services/cs-context";
import TileKebabMenu from "../../components/tile-kebab-menu.vue";
import cms from "../../services/cms/cms";
import { CmsPersonalPathway } from "../../services/cms/cms-type-definitions";
import useSelectPersonalPathway from "../../composables/useSelectPersonalPathway";
import LoadingSpinner from "../../components/loading-spinner.vue";
import { InviteControlApiModel, ProfileApiModel } from "../../api-models";
import { useAxios } from "../../composables/api";
import ViewpointsInviteDialog from "../../components/invite-control/viewpoints-invite-dialog.vue";
import AdHocReportPicker from "../../components/my-reports/ad-hoc-report-picker.vue";
import uiConfig from "../../ui-config";


export default /*#__PURE__*/_defineComponent({
  __name: 'my-dashboard',
  setup(__props) {

const debug = d("cs.MyDashboard");

const outcomeTile = ref();
const soloTileKebab = ref();
const viewpointsTileKebab = ref();
const userId = ref(csContext.user.id);
const userProfile = ref<ProfileApiModel>(csContext.userProfile);
const isSoloHeadLoaded = ref(false);
const isOutcomeModalDisplayed = ref(false);
const isSelectingSoloReportPathway = ref(false);
const soloReportPathway = ref<CmsPersonalPathway | null>(null);
const isSoloReportPathwaySelectionLoading = ref(false);
const soloReportPathwayError = ref(false);
const isViewpointsHeadLoaded = ref(false);
const hasViewpointsReport = ref(false);
const viewpointsInviteDialog = ref<InstanceType<typeof ViewpointsInviteDialog>>();
const isAdHocReportPickerShown = ref(false);
// this is a flag to hide the adhoc report creation menu item until the adhoc reports are ready for production
const { isInBeta } = uiConfig;

const { data: inviteControlModel, promise: inviteControlModelPromise } =
  useAxios<InviteControlApiModel>("/InviteCodes/ViewpointsReviewInviteModel");

const onKebabOpen = () => {
  if (outcomeTile.value.outcomeTileKebab) {
    outcomeTile.value.outcomeTileKebab.close();
  }
  soloTileKebab.value.close();
  viewpointsTileKebab.value?.close();
};

const lastCompletedDayIndex = computed(() =>
  userProfile.value?.developProgress
    ? userProfile.value.developProgress.currentStrengthProgress.lastCompletedDayIndex
    : undefined,
);

function soloHeadLoaded(hasData: boolean): void {
  debug("soloDiamondLoaded", hasData);
  if (!hasData) return;
  isSoloHeadLoaded.value = true;
}

async function getWorkingWithYourSoloReportPathway() {
  const pathwayUid = "working-with-your-solo-report";
  soloReportPathway.value = await cms.getByUid("cms-personal-pathway", pathwayUid);
}

const isChangeOutcomeModalOkButtonDisabled = computed<boolean>(() => {
  return isSelectingSoloReportPathway.value && !soloReportPathway.value;
});

function viewpointsHeadLoaded(hasData: boolean): void {
  debug("viewpointsDiamondLoaded", hasData);
  isViewpointsHeadLoaded.value = true;
  hasViewpointsReport.value = hasData;
}

function showViewpointsInviteDialog(): void {
  if (inviteControlModel.value) {
    viewpointsInviteDialog.value?.open(inviteControlModel.value).finally(() => {
      viewpointsInviteDialog.value?.close();
    });
  }
}

function openViewpointsInviteDialog(): void {
  debug("openViewpointsInviteDialog");
  if (inviteControlModel.value) {
    debug("showing immediately");
    showViewpointsInviteDialog();
  } else {
    debug("deferring show");
    inviteControlModelPromise?.then(() => {
      debug("showing after deferral");
      showViewpointsInviteDialog();
    });
  }
}

const handleChangeOutcomeModalShow = async (
  hasSelectedSoloReportPathway: boolean,
): Promise<void> => {
  isOutcomeModalDisplayed.value = true;
  isSelectingSoloReportPathway.value = hasSelectedSoloReportPathway;

  if (hasSelectedSoloReportPathway) {
    await getWorkingWithYourSoloReportPathway();
  }
};

const selectWorkingWithSoloReportPathway = (): void => {
  if (soloReportPathway.value) {
    const { error, success, isLoading } = useSelectPersonalPathway(soloReportPathway.value);
    isSoloReportPathwaySelectionLoading.value = isLoading.value;
    soloReportPathwayError.value = error.value;

    watch([success], (newValue) => {
      if (newValue) {
        window.location.href = "/my/pathway/working-with-your-solo-report";
      }
    });
  }
};

const handleChangeOutcomeHide = (msg: "ok" | "cancel"): void => {
  if (msg === "ok") {
    if (isSelectingSoloReportPathway.value && soloReportPathway.value) {
      selectWorkingWithSoloReportPathway();
    } else {
      window.location.href = "/my/outcomes/";
    }
  }
};

function handleAdhocReportClick() {
  isAdHocReportPickerShown.value = true;
}

function hideAdHocReportPicker() {
  isAdHocReportPickerShown.value = false;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ViewpointsInviteDialog, {
      ref_key: "viewpointsInviteDialog",
      ref: viewpointsInviteDialog,
      "data-test": "md-invite-modal"
    }, null, 512),
    _createVNode(AdHocReportPicker, {
      ref: "adHocReportsPicker",
      shown: isAdHocReportPickerShown.value,
      onClose: hideAdHocReportPicker,
      "data-test": "md-ad-hoc-reports-picker"
    }, null, 8, ["shown"]),
    _createVNode(_unref(Modal), {
      modelValue: isOutcomeModalDisplayed.value,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((isOutcomeModalDisplayed).value = $event)),
      title: "Change Pathway?",
      "ok-text": "Yes",
      "cancel-text": "Cancel",
      "cancel-type": "primary",
      "ok-type": "default",
      onHide: handleChangeOutcomeHide,
      size: "sm",
      "data-test": "md-change-outcome-modal"
    }, _createSlots({
      title: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        (isSoloReportPathwaySelectionLoading.value)
          ? (_openBlock(), _createBlock(LoadingSpinner, {
              key: 0,
              "data-test": "change-outcome-loading"
            }))
          : (soloReportPathwayError.value)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Oops, something went wrong. Please try again. "))
            : (isSelectingSoloReportPathway.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, " Selecting this pathway will replace your current pathway and your progress will not be saved. Would you still like to initiate this pathway? "))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_8))
      ]),
      _: 2
    }, [
      (isSelectingSoloReportPathway.value)
        ? {
            name: "footer",
            fn: _withCtx(() => [
              _createElementVNode("button", {
                class: "btn btn-primary",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (isOutcomeModalDisplayed.value = false)),
                "data-test": "close-change-outcome-btn",
                type: "button"
              }, " Cancel "),
              _createElementVNode("button", {
                class: "btn btn-default",
                disabled: isChangeOutcomeModalOkButtonDisabled.value,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (handleChangeOutcomeHide('ok'))),
                "data-test": "select-solo-report-pathway-btn",
                type: "button"
              }, " Yes ", 8, _hoisted_9)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["modelValue"]),
    _createElementVNode("section", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(DashboardOutcomeTile, {
              ref_key: "outcomeTile",
              ref: outcomeTile,
              onOpenKebab: onKebabOpen,
              "onUpdate:isChangeOutcomeModalDisplayed": _cache[3] || (_cache[3] = ($event: any) => (handleChangeOutcomeModalShow(false)))
            }, null, 512)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createVNode(DashboardPanel, {
                  href: "/soloreport/",
                  "is-clickable": isSoloHeadLoaded.value,
                  title: "Solo",
                  "tooltip-text": "My Solo report shows me how I see myself",
                  "data-test": "md-solo-tile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TileKebabMenu, {
                      ref_key: "soloTileKebab",
                      ref: soloTileKebab,
                      "data-test": "solo-kebab-menu",
                      onOpenKebab: onKebabOpen
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17,
                        _hoisted_18,
                        _hoisted_19
                      ]),
                      _: 1
                    }, 512),
                    _createElementVNode("div", {
                      class: _normalizeClass([{ hidden: !isSoloHeadLoaded.value }, "panel-head-container"])
                    }, [
                      _createVNode(HeadFromModel, {
                        "animate-entrance": true,
                        "head-id": userId.value,
                        kind: "solo",
                        onOnDataLoaded: soloHeadLoaded,
                        "data-test": "md-solo-head"
                      }, null, 8, ["head-id"])
                    ], 2)
                  ]),
                  _: 1
                }, 8, ["is-clickable"])
              ]),
              _createElementVNode("div", _hoisted_20, [
                _createVNode(DashboardPanel, {
                  href: hasViewpointsReport.value ? '/viewpoints/' : '/my/pathway/viewpoints-invite',
                  title: "Viewpoints",
                  "tooltip-text": "My Viewpoints report shows how others view me",
                  "is-clickable": isViewpointsHeadLoaded.value,
                  "data-test": "md-vp-tile"
                }, {
                  default: _withCtx(() => [
                    _createVNode(TileKebabMenu, {
                      ref_key: "viewpointsTileKebab",
                      ref: viewpointsTileKebab,
                      "data-test": "viewpoints-kebab-menu",
                      onOpenKebab: onKebabOpen
                    }, {
                      default: _withCtx(() => [
                        (hasViewpointsReport.value)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_21, _hoisted_23))
                          : _createCommentVNode("", true),
                        (hasViewpointsReport.value)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_24, _hoisted_26))
                          : _createCommentVNode("", true),
                        _createElementVNode("li", { "data-test": "viewpoints-menu-item-2" }, [
                          _createElementVNode("a", {
                            href: "javascript:void(0)",
                            onClick: openViewpointsInviteDialog
                          }, "Invite people to review me")
                        ]),
                        _hoisted_27,
                        (hasViewpointsReport.value)
                          ? (_openBlock(), _createElementBlock("li", _hoisted_28, _hoisted_30))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 512),
                    (isViewpointsHeadLoaded.value && !hasViewpointsReport.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_31, _hoisted_34))
                      : (!isViewpointsHeadLoaded.value || hasViewpointsReport.value)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: _normalizeClass([{ hidden: !isViewpointsHeadLoaded.value || !hasViewpointsReport.value }, "panel-head-container"])
                          }, [
                            _createVNode(HeadFromModel, {
                              animateEntrance: true,
                              headId: userId.value,
                              kind: "viewpoints",
                              onOnDataLoaded: viewpointsHeadLoaded,
                              "data-test": "md-viewpoints-head"
                            }, null, 8, ["headId"])
                          ], 2))
                        : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["href", "is-clickable"])
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("div", _hoisted_36, [
                _createVNode(DashboardPanel, {
                  title: "My Reports",
                  href: "/my/reports",
                  "data-test": "md-reports-tile"
                }, {
                  default: _withCtx(() => [
                    (_unref(isInBeta))
                      ? (_openBlock(), _createBlock(TileKebabMenu, {
                          key: 0,
                          ref: "myReportsTileKebab",
                          "data-test": "my-reports-kebab-menu",
                          onOpenKebab: onKebabOpen
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("li", _hoisted_37, [
                              _createElementVNode("a", {
                                href: "javascript:void(0)",
                                onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (handleAdhocReportClick()), ["prevent"]))
                              }, "Create Ad Hoc Report...")
                            ])
                          ]),
                          _: 1
                        }, 512))
                      : _createCommentVNode("", true),
                    _hoisted_38
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createVNode(DashboardPanel, {
                  title: "Develop",
                  "tooltip-text": "Choose one of Gyre’s 34 Strengths to develop over a 25-day plan",
                  "data-test": "md-develop-tile",
                  href: 
                    !!userProfile.value && !!userProfile.value.developProgress && lastCompletedDayIndex.value < 25
                      ? '/develop'
                      : '/resources/playlists/the-34-strengths'
                  
                }, {
                  default: _withCtx(() => [
                    (userProfile.value && userProfile.value.developProgress)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                          _createElementVNode("span", _hoisted_41, _toDisplayString(userProfile.value.developProgress?.currentStrengthProgress.strengthItemDisplayTitle), 1),
                          (lastCompletedDayIndex.value > 24)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, _hoisted_46))
                            : _createCommentVNode("", true),
                          _createVNode(DevelopProgress, {
                            model: userProfile.value.developProgress,
                            class: "develop-progress"
                          }, null, 8, ["model"]),
                          (lastCompletedDayIndex.value < 25)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_47, "Day " + _toDisplayString(lastCompletedDayIndex.value + 1) + " of 25", 1))
                            : (_openBlock(), _createElementBlock("button", _hoisted_48, " Choose a new plan "))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_52))
                  ]),
                  _: 1
                }, 8, ["href"])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})